import * as yup from "yup";

export const requestChatSchema = yup
  .object({
    message: yup.string().required(),
  })
  .required();
